/* ============================================================
   HORCERY — UGC clip wall: lazy, muted, in-view playback.
   Tiles paint as a poster image. A clip only downloads once its
   tile is nearly on screen, then loops silently; it pauses the
   moment it scrolls away or the tab is hidden, so the wall costs
   about what the old image version cost until someone engages.
   Reduced-motion / Data Saver / 2G → posters only, tap to play.

   A tile with no outbound link is a <button>, and that button IS
   the play/pause control — native <video controls> would nest a
   control inside a button and trap keyboard focus.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || navigator.webkitConnection || {};
  var thrifty = conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || '');

  // Keeps the button's screen-reader label honest without losing the handle.
  function setLabel(label, paused) {
    if (!label) return;
    label.textContent = label.textContent.replace(/^(Play|Pause)\b/, paused ? 'Play' : 'Pause');
  }

  function track(tile, v, label) {
    v.addEventListener('playing', function () {
      tile.classList.add('is-playing');
      setLabel(label, false);
    });
    v.addEventListener('pause', function () {
      tile.classList.remove('is-playing');
      setLabel(label, true);
    });
    v.addEventListener('ended', function () {
      tile.classList.remove('is-playing');
      setLabel(label, true);
    });
  }

  // Autoplay only ever happens muted — browsers block anything else.
  function start(v) {
    v.muted = true;
    v.loop = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* blocked → poster stays put */ });
  }

  function initUgc(section) {
    if (!section || section.__hzInit) return;
    section.__hzInit = true;

    var tiles = Array.prototype.slice.call(section.querySelectorAll('[data-hz-ugc-tile]'))
      .filter(function (t) { return !!t.querySelector('video'); });
    if (!tiles.length) return;

    tiles.forEach(function (tile) {
      var v = tile.querySelector('video');
      v.removeAttribute('autoplay');
      v.removeAttribute('controls');
      v.controls = false;

      var label = tile.querySelector('[data-hz-ugc-label]');
      track(tile, v, label);

      if (tile.tagName !== 'BUTTON') return;
      tile.addEventListener('click', function () {
        v.__hzUser = true;                    // visitor is driving from here on
        if (v.paused) { v.muted = false; v.play(); } else { v.pause(); }
      });
    });

    var autoplay = section.getAttribute('data-hz-ugc-autoplay') !== 'false';
    if (!autoplay || reduce || thrifty || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target.querySelector('video');
        if (!v) return;
        // Always stop off-screen clips — including one a visitor unmuted, which
        // must never keep playing audio after it has scrolled out of sight.
        if (!entry.isIntersecting) { v.pause(); return; }
        if (v.__hzUser) return;               // don't wrestle a clip back off the visitor
        start(v);
      });
    }, { threshold: 0.4 });

    tiles.forEach(function (tile) { io.observe(tile); });

    function onVisibility() {
      if (!document.hidden) return;
      tiles.forEach(function (tile) {
        var v = tile.querySelector('video');
        if (v) v.pause();
      });
    }
    document.addEventListener('visibilitychange', onVisibility);

    section.__hzCleanup = function () {
      io.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }

  function teardown(el) {
    if (!el) return;
    if (el.__hzCleanup) { el.__hzCleanup(); el.__hzCleanup = null; }
    el.__hzInit = false;
  }

  function initAll() { document.querySelectorAll('[data-hz-ugc]').forEach(initUgc); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-ugc]');
    if (el) { teardown(el); initUgc(el); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-hz-ugc]');
    if (el) teardown(el);
  });
})();
